export default function File(props) {
    const fill = props.fill ?? '#212121';

    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 21">
            <path
                fill={fill}
                fillRule="evenodd"
                d="M12 0H.75v21H18V6l-6-6zm-1.5 7.5h5.25L10.5 2.25V7.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
